import { ChevronRight } from 'lucide-react';
import { Fragment, ReactNode } from 'react';
import { Link } from 'react-router';

import { cn } from './cn';

export type BreadcrumbItem = {
  label: ReactNode;
  href?: string;
};

export interface BreadcrumbProps {
  items: BreadcrumbItem[];
  className?: string;
}

/** Compact trail of links ending at the current page. */
export const Breadcrumb = ({ items, className }: BreadcrumbProps) => {
  if (items.length === 0) {
    return null;
  }

  return (
    <nav aria-label="Breadcrumb" className={cn('min-w-0', className)}>
      <ol className="m-0 flex list-none flex-wrap items-center gap-1 p-0 text-xs text-ink-muted">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <Fragment key={index}>
              {index > 0 && (
                <li aria-hidden="true" className="inline-flex text-ink-subtle">
                  <ChevronRight className="size-3.5" />
                </li>
              )}
              <li
                className={cn('min-w-0 truncate', isLast ? 'font-medium text-ink' : undefined)}
                aria-current={isLast ? 'page' : undefined}
              >
                {!isLast && item.href ? (
                  <Link to={item.href} className="text-ink-muted no-underline hover:text-brand hover:underline">
                    {item.label}
                  </Link>
                ) : (
                  item.label
                )}
              </li>
            </Fragment>
          );
        })}
      </ol>
    </nav>
  );
};
